var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.33,
    height: 37.331,
    viewBox: "0 0 37.33 37.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-alt-solid",
    d: "M18.665,21a10.5,10.5,0,1,0-10.5-10.5A10.5,10.5,0,0,0,18.665,21ZM28,23.332H23.98a12.692,12.692,0,0,1-10.63,0H9.333A9.332,9.332,0,0,0,0,32.664v1.167a3.5,3.5,0,0,0,3.5,3.5H33.831a3.5,3.5,0,0,0,3.5-3.5V32.664A9.332,9.332,0,0,0,28,23.332Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.b1e8ec113934e4342be8eed2b344a114.svg";
export { ForwardRef as ReactComponent };